import { useQuery, useQueryClient } from '@tanstack/react-query';
import { findPetBySlug } from '../utils/petSlug';

const usePetSingle = petId => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ['pets', petId],
    queryFn: async () => {
      // pokušaj dohvatiti sve pse iz cache-a
      const allPets = queryClient.getQueryData(['pets']);

      // prvo pokušaj naći direktno po ID-u (ako je unet ID)
      let pet = allPets?.find(p => p._id === petId);

      if (pet) {
        return pet;
      }

      // ako nije pronađen po ID-u, pokušaj kao slug (npr. 'fluffy-1')
      if (allPets) {
        pet = findPetBySlug(allPets, petId);
        if (pet) {
          return pet;
        }
      }

      console.log('Fetching pet from API, petId/slug:', petId);

      // ako nije došao sa glavne stranice, fetch sa API-ja
      const fetchedPets = await fetch(
        import.meta.env.VITE_PAWFRIENDS_API_ENDPOINT_GET_DOGS
      ).then(res => res.json());

      queryClient.setQueryData(['pets'], fetchedPets);

      // pokušaj ponovo po ID-u
      pet = fetchedPets.find(p => p._id === petId);
      if (pet) {
        return pet;
      }

      // pokušaj po slug-u
      pet = findPetBySlug(fetchedPets, petId);
      if (pet) {
        return pet;
      }

      return null;
    },
    staleTime: 1000 * 60 * 30, // 30 minuta
  });
};

export default usePetSingle;
